import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EarlyAccessComponent } from './early-access.component';
import { SharedModule } from '../../shared/shared.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    EarlyAccessComponent
  ],
  imports: [
    MatSlideToggleModule,
    CommonModule,
    SharedModule,
    RouterModule,
  ]
})
export class EarlyAccessModule {}
